import React, { useEffect, useState } from "react";
import CookieConsent from "react-cookie-consent";

const GDPRConsent = ({ clarityId, children }) => {
  const [loaded, setLoaded] = useState(false);

  // function to inject the Clarity script when consent is given
  const loadClarity = () => {
    if (!clarityId) return;
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${clarityId}`;
    document.head.appendChild(script);
  };

  // on mount, check localStorage for prior consent
  useEffect(() => {
    const consent = window.localStorage.getItem("gdpr_consent_clarity");
    if (consent === "yes") {
      loadClarity();
      setLoaded(true);
    }
  }, []);

  const handleAccept = () => {
    window.localStorage.setItem("gdpr_consent_clarity", "yes");
    loadClarity();
    setLoaded(true);
  };

  // user declines consent: hide banner but do not block children
  const handleDecline = () => {
    window.localStorage.setItem("gdpr_consent_clarity", "no");
    setLoaded(true);
  };

  return (
    <>
      {children}
      {!loaded && (
        <CookieConsent
          location="bottom"
          buttonText="قبول"
          declineButtonText="رد کردن"
          enableDeclineButton
          onAccept={handleAccept}
          onDecline={handleDecline}
          style={{
            background: "#fff",
            textAlign: "center",
            padding: "10px 8px",
            border: "2px solid #000",
            borderRadius: "8px",
            margin: "10px 8px",
          }}
          contentStyle={{
            color: "#000",
            textAlign: "center",
            fontSize: "13px",
            lineHeight: "1.2",
          }}
          buttonStyle={{
            background: "#000",
            color: "#fff",
            fontSize: "13px",
            border: "none",
            borderRadius: "4px",
            margin: "0 8px",
            padding: "8px 16px",
          }}
          declineButtonStyle={{
            background: "#fff",
            color: "#000",
            fontSize: "13px",
            border: "1px solid #000",
            borderRadius: "4px",
            margin: "0 8px",
            padding: "8px 16px",
          }}
        >
          این وب‌سایت برای تحلیل رفتار کاربر از کوکی استفاده می‌کند. <a href="/privacy" style={{ color: "#FFD700" }}>سیاست حفظ حریم خصوصی</a> را مطالعه کنید.
        </CookieConsent>
      )}
    </>
  );
};

export default GDPRConsent; 